import Vue from 'vue'
import useJwt from '@/auth/jwt/useJwt'

export default {
  name: 'ActiveCompanyComponent',
  data: {
    company: null,
  },
  install() {
    Vue.prototype.$activeCompany = () => this
  },
  hasTag(tag) {
    return this.data.company.tags?.includes(tag) || false
  },
  syncFromProfile() {
    const { user } = Vue.prototype.$profile().data
    if (!user) {
      return
    }

    const companies = [...(user.companies || []), ...(user.authorisations || [])]
    const currentId = this.data.company?.id || useJwt.getActiveCompany()?.id
    const fresh = companies.find(company => company.id === currentId)
    if (fresh) {
      this.data.company = fresh
      useJwt.setActiveCompany(fresh)
      return
    }

    if (!this.data.company) {
      this.fetchCompany()
    }
  },
  fetchCompany() {
    if (Vue.prototype.$profile().data.user !== null && !this.data.company) {
      if (!useJwt.getActiveCompany() || useJwt.getActiveCompany() === 'null') {
        const companiesList = Vue.prototype.$profile().data.user.companies
        if (companiesList && companiesList.length > 0) {
          let company = companiesList[0]
          if (Vue.prototype.$profile().data.user.last_login_company_id) {
            companiesList.forEach(item => {
              if (item.id === Vue.prototype.$profile().data.user.last_login_company_id) {
                company = item
              }
            })
          }

          useJwt.setActiveCompany(company)
        }
      }
      this.data.company = useJwt.getActiveCompany()
    }
  },
}
